import { css, cx } from '@onbeam/business-styled-system/css';
import { TargetsSectionItemProps } from './TargetsSectionItem.types';
import { vstack } from '@onbeam/business-styled-system/patterns';

export const TargetsSectionItem = ({
  title,
  icon: Icon,
  className,
  iconClassName,
}: TargetsSectionItemProps) => (
  <div
    className={cx(
      vstack({
        gap: '1',
        textAlign: 'center',
        align: 'center',
        maxW: '[14.625rem]',
        textStyle: 'body-lg',
        mx: 'auto',
      }),
      className,
    )}
  >
    <Icon className={cx(css({ mb: '3' }), iconClassName)} />
    <span>{title}</span>
  </div>
);
